export default __webpack_public_path__ + "static/media/16.7ec0faf1.jpg";